import { React, useState,useEffect ,useRef } from "react";
import ContactPopup from "../ContactPopup";
// import "./ServicePage.css";
import "../ImportExport/ServicePages.css";

const FSSAIReturnFiling = () => {

const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }



  useEffect(() => {
    document.title = "FSSAI Return Filing Service | Annual & Half-Yearly Returns India";

    const meta = document.createElement("meta");
    meta.name = "description";
    meta.content =
      "File your FSSAI returns online with expert assistance. Annual (D1) and Half-Yearly (D2) return filing for food businesses in India. Avoid penalties with timely compliance.";
    document.head.appendChild(meta);
  }, []);

  return (
    <div className="service-page">

      {/* HERO */}
      <section className="service-hero">
        <h1>FSSAI Return Filing Service</h1>
        <p>Annual & Half-Yearly Compliance for Food Businesses in India</p>
        <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>
        <p>
          FSSAI return filing is a mandatory compliance for all Food Business Operators (FBOs)
          holding an FSSAI license. It ensures that your business activities, production,
          and sales details are properly reported to the Food Safety and Standards Authority of India.
        </p>
        <p>
          Timely filing helps you avoid penalties and keeps your food business legally compliant.
        </p>
      </section>

      {/* WHO NEEDS */}
      <section className="service-section">
        <h2>Who Needs to File FSSAI Returns?</h2>
        <div className="card">Food Manufacturers</div>
        <div className="card">Importers & Exporters</div>
        <div className="card">Distributors & Suppliers</div>
        <div className="card">Restaurants & Cloud Kitchens</div>
        <div className="card">E-commerce Food Sellers</div>
        <p style={{ marginTop: "10px", color: "gray" }}>
          If you have an FSSAI license, return filing is compulsory.
        </p>
      </section>

      {/* TYPES */}
      <section className="service-section">
        <h2>Types of FSSAI Returns</h2>

        <div className="card">
          <strong>Annual Return (Form D1)</strong>
          <ul>
            <li>Applicable for manufacturers, importers, and labelers</li>
            <li>Covers details of food products handled during the year</li>
            <li><strong>Due date:</strong> 31st May of every year</li>
          </ul>
        </div>

        <div className="card">
          <strong>Half-Yearly Return (Form D2)</strong>
          <ul>
            <li>Applicable for milk & milk product manufacturers</li>
            <li>Covers production details</li>
            <li><strong>Due dates:</strong></li>
            <li>1st April – 30th September → 31st October</li>
            <li>1st October – 31st March → 30th April</li>
          </ul>
        </div>

      </section>

      {/* SERVICES */}
      <section className="service-section">
        <h2>Our FSSAI Return Filing Services Include</h2>
        <ul>
          <li>Preparation and filing of FSSAI returns</li>
          <li>Data collection and verification</li>
          <li>Compliance review</li>
          <li>Timely reminders before due dates</li>
          <li>Error-free submission</li>
          <li>Support for notices or corrections</li>
        </ul>
      </section>

      {/* PENALTY */}
      <section className="service-section">
        <h2>Penalties for Late Filing</h2>
        <div className="card" style={{ background: "#fff3f3", border: "1px solid #ffcccc" }}>
          Delay in filing FSSAI returns attracts a penalty of <strong>₹100 per day</strong>,
          which can accumulate quickly and increase compliance risk.
        </div>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>
        <div className="card">FSSAI License Details</div>
        <div className="card">Business Information</div>
        <div className="card">Product & Sales Data</div>
        <div className="card">Import/Export Details (if applicable)</div>
      </section>

      {/* WHY US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>✔ Experienced compliance professionals</li>
          <li>✔ Timely filing with reminders</li>
          <li>✔ Affordable pricing</li>
          <li>✔ Hassle-free process</li>
          <li>✔ Dedicated support</li>
        </ul>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Avoid Penalties. Stay Compliant.</h2>
        <p>Let us handle your FSSAI return filing smoothly and on time.</p>
        <button>Get Started</button>
      </section> */}

    
         <div className="cta" ref={contactRef}>
              <h2>Avoid Penalties. Stay Compliant.</h2>
              <p>Let us handle your FSSAI return filing smoothly and on time.</p>
      
              <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Get Started</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
            </div>
    </div>
  );
};

export default FSSAIReturnFiling;